import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { burlingtonConfig } from "./data";

export default function BurlingtonPage() {
  return <CityPageTemplate config={burlingtonConfig} />;
}